import React, { useState, useEffect } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import { Form, TextInput, SaveButton, useNotify, useRefresh, useUpdate } from 'react-admin';
import { DecisionTypes } from 'src/constants/choices/ach.transfers.choices';
import { SearchTransferItem } from 'src/models';

import Styles from '../../constants/styles';

export interface DecideTransferModalProps {
  type: DecisionTypes;
  element: SearchTransferItem;
  openModal: boolean;
  modalClosed?: any;
  onSubmit?: any;
}

const DecideTransferModal = ({
  type = DecisionTypes.REP_APPROVE,
  element,
  openModal = false,
  modalClosed = function () {},
  onSubmit = null,
}: DecideTransferModalProps) => {
  const [open, setOpen] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(false);

  const handleClose = () => {
    setOpen(false);
    modalClosed();
  };
  useEffect(() => {
    setOpen(openModal);
  }, [openModal]);

  const notify = useNotify();
  const refresh = useRefresh();
  const [update] = useUpdate();

  const getHeaderText = (type: DecisionTypes) => {
    switch (type) {
      case DecisionTypes.REP_APPROVE:
        return 'Representative Approve Transfer';
      case DecisionTypes.FIRM_APPROVE:
        return 'Firm Approve Transfer';
      case DecisionTypes.REJECT:
        return 'Reject Transfer';
      case DecisionTypes.CANCEL:
        return 'Cancel Transfer';
      case DecisionTypes.EDIT:
        return 'Edit Transfer';
    }
  };

  const getButtonText = (type: DecisionTypes) => {
    switch (type) {
      case DecisionTypes.REP_APPROVE:
      case DecisionTypes.FIRM_APPROVE:
        return 'APPROVE';
      default:
        return type;
    }
  };

  const getNotificationMessage = (type: DecisionTypes) => {
    switch (type) {
      case DecisionTypes.REP_APPROVE:
      case DecisionTypes.FIRM_APPROVE:
        return notify('Approved successfully', { type: 'success' });
      case DecisionTypes.REJECT:
        return notify('Rejected successfully', { type: 'success' });
      case DecisionTypes.CANCEL:
        return notify('Canceled successfully', { type: 'success' });
      case DecisionTypes.EDIT:
        return notify('Edited successfully', { type: 'success' });

      default:
        break;
    }
  };

  const handleSubmit = (dataToUpdate: any) => {
    if (onSubmit) return onSubmit(dataToUpdate);

    setBtnDisabled(true);
    update(
      'ACHTransfer.' + type,
      {
        id: dataToUpdate.transferId,
        data: {
          accountId: dataToUpdate.accountId,
          note: dataToUpdate.note,
          adminNote: dataToUpdate.admiNNote,
          comment: dataToUpdate.comment,
        },
      },
      {
        onError: (error: any) => {
          notify(error.message ?? 'An uncaught error occurred!', { type: 'error' });
          handleClose();
        },
        onSuccess: () => {
          handleClose();
          getNotificationMessage(type);
          refresh();
        },
        onSettled: () => {
          setBtnDisabled(false);
        },
      },
    );
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'>
        <Box sx={Styles.achRelationship.modal}>
          <Typography variant='h6' component='h2'>
            {getHeaderText(type)}
          </Typography>

          <Form onSubmit={handleSubmit} defaultValues={element}>
            {type === DecisionTypes.CANCEL ? (
              <TextInput source='comment' fullWidth multiline />
            ) : (
              <TextInput source='note' fullWidth multiline />
            )}

            <div style={{ display: 'flex', justifyContent: 'space-between', margin: 10 }}>
              <Button variant='outlined' color='inherit' onClick={handleClose}>
                Close
              </Button>
              <SaveButton disabled={btnDisabled} label={btnDisabled ? 'Loading' : getButtonText(type)} />
            </div>
          </Form>
        </Box>
      </Modal>
    </div>
  );
};

export default DecideTransferModal;
